import { render } from "./CartSummary.vue?vue&type=template&id=9bf6ccea&ts=true"
import script from "./CartSummary.vue?vue&type=script&lang=ts"
export * from "./CartSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__